export default __webpack_public_path__ + "static/identify-light-31e74411309e45239a0f3c86b2209c02.png";